<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <h3 class="tw-pt-8 tw-text-center tw-mx-auto tw-pb-4 tw-font-bold">Pour bénéficier de -15 de réduction utilisez le code :</h3>
            <div class="code tw-mx-auto tw-flex tw-items-center tw-justify-center tw-text-center tw-mb-3">
                EMAIL15PREF
            </div>
            <p class="tw-py-4 tw-font-base">Vous venez de réaliser votre demande de devis avec St Maclou.<br>Un conseiller vous rappelle très vite.</p>
            <p class="tw-pt-2 tw-pb-5 tw-font-base">Vous serez redirigé vers <a href="https://www.saint-maclou.com" target="_blank">www.saint-maclou.com</a> dans {{seconds}} secondes</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
    data() {
        return {
            seconds: 15,
        };
    },
    mounted() {
        this.countdown();
    },
    methods: {
        countdown() {
            var min = 0;

            var count = setInterval(() => {
                this.seconds--;
                if(this.seconds === min) {
                clearInterval(count);
                    window.location.href="https://www.saint-maclou.com";
                }
            }, 1000);
        },
    },
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    a {
        color: $yellow;
        text-decoration: underline;
    }

    h3 {
        color: $main_color;
        @screen lg {
            font-size: 30px;
        }
    }

    .code {
        border: dashed 1px $main_color;
        color: $yellow;
        font-weight: 700;
        width: fit-content;
        padding: 1.5px 15px;
        font-size: 30px;

        @screen lg {
            font-size: 40px;
            padding: 1.5px 30px;
        }
    }
}

</style>
